(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('agendaTime', ['HelperService', TimeDirectiveFn]);

    /* time directive for displaying hour:minutes */
    function TimeDirectiveFn(HelperService) {
        var directive = {
            link: link,
            restrict: 'E',
            replace: false,
            template: '<input type="text" datetimepicker on-change="changed()" ng-model="interact" options="::options" class="form-control" />',
            scope: {
                model: '=',
                nullable: '&?' // can time be null
            }
        };
        return directive;

        function link(scope, element) {
            activate();
            // picker
            var picker = element.children().eq(0).data('DateTimePicker');

            // date to interact with picker
            scope.interact = scope.model;
            // format
            var format = 'LT';

            // options of picker
            scope.options = {
                locale: moment.locale(),
                format: format,
                showClear: true,
                allowInputToggle: true
            };

            // set options
            element.datetimepicker(scope.options);

            // if date changes
            scope.changed = function () {
                if (scope.interact) {
                    scope.model = scope.interact.local().format();
                } // if
                else {
                    scope.model = null;
                } // else 
            };

            // on click show picker
            element.on("click", function (event) {
                picker.show();
            });

                     

            // watch on changes
            var watchUnbinder = scope.$watch('model', function (newVal) {
                scope.model = HelperService.backendDate(newVal);
            })

            // on destroy
            scope.$on('$destroy', function () {
                watchUnbinder();
                watchUnbinder = null;
                scope.interact = null;
                format = null;
                scope.options = null;
                element.off("click");
                element = null;
                picker.destroy();
                picker = null;
            });

            /* activation */
            function activate() {
                // model to interact
                if (scope.model && scope.model !== null && typeof scope.model !== 'undefined') {
                    scope.interact = HelperService.time(scope.model);
                } // if
                else {
                    // can be nullable ?
                    if (scope.nullable === 'false' || scope.nullable === false) {

                        scope.interact = new Date();
                        scope.interact.setUTCHours(0);
                        scope.interact.setUTCMinutes(0);
                        scope.interact.setUTCSeconds(0);
                        scope.interact.setUTCMilliseconds(0);
                        // make correct date to interact with control
                        scope.interact = HelperService.time(scope.interact);
                    } //if
                } // else

            }

        }
    }

})();